export default ($t) => ({
  title: "TeamDonationNotificationBySms",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
    },
    sms_template: {
      title: $t(
        "edit_campaign.schema_team_donation_notification_by_sms_template_body",
        "SMS body content"
      ),
      type: "string",
      default: "",
      description: $t(
        "edit_campaign.schema_team_donation_notification_by_sms_template_body_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
  },
});
